export const getNames = (data: Array<{ name: string }>): string[] => {
    const listOfNames = new Set<string>();

    data.forEach((val) => (
        listOfNames.add(val.name)
    ));

    return [...listOfNames];
};

type GraphqlLeafValue = string | { label: string; value?: string } | { value: { in: unknown[] } } | { some: { value: { in: unknown[] } } };
type SchemaObject = { [key: string]: GraphqlLeafValue | SchemaObject };

export const generateObjFromDataPath = (dataPath = '', value: GraphqlLeafValue = ''): SchemaObject => {
    if (!dataPath) return {};

    return dataPath
        .split('.')
        .reduceRight(
            (acc, item, index, arr) => ({ [item]: index + 1 < arr.length ? acc : value }),
            {} as SchemaObject,
        );
};

export const convertObjToGraphQLSchema = (schemaObj: unknown): string => (
    JSON.stringify(schemaObj)
        .replaceAll('"', ' ')
        .replaceAll(',', ' ')
        .replaceAll(':', ' ')
);
